import { LISTING_FIELDS } from '../../util/soulwise-marketplace/listingFields';

export const fieldsSupportingTextMapping = {
  [LISTING_FIELDS.onlineMeeting]: {
    formatMessageId: 'FieldSupportingText.onlineMeeting',
  },
};

/**
 * Get supporting text message for field
 * @param {String} key
 * @param {Object} intl
 * @return {*|null}
 */
export const getSupportingTextMessage = (key, intl) => {
  const fieldSupportingText = fieldsSupportingTextMapping[key];
  return fieldSupportingText
    ? intl.formatMessage({ id: fieldSupportingText.formatMessageId })
    : null;
};
